export default __webpack_public_path__ + "media/images/react_icons/comment-exclamation-a477ece43d8127a2e4e8e1f3a11a3aa5.svg";